export const TEST_ID = 'applicationsGrid';
